<template>
  <div
    id="media"
    class="media"
  >
    <v-toolbar class="elevation-0 transparent media-toolbar">

        <v-text-field
        class="mx-3"
        flat
        label="Search"
        prepend-icon="search"
        v-model="search"
        clearable
        @click:clear="clearSearch"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn-toggle v-model="view">
        <v-btn
          flat
          value="list"
        >
          <v-icon color="primary">view_headline</v-icon>
        </v-btn>
        <v-btn
          flat
          value="grid"
        >
          <v-icon color="primary">calendar_today</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-toolbar>
    <v-divider></v-divider>
    <div class="layout row media-layout">
      <div class="media-content flex transparent">
        <app-section-loader :status="loader"></app-section-loader>

        <v-container
          fluid
          v-if="view ==='grid'"
        >
          <v-layout
            row
            wrap
            class="x-grid-lg"
          >
            <v-flex
              lg12
              sm12
              xs12
            >
              <full-calendar
                class="fullwidth"
                :events="filteredItems"
                @dayClick="handleDayClick"
                @eventClick="handleEventClick"
              >
              </full-calendar>
            </v-flex>

          </v-layout>
        </v-container>
        <v-layout
          column
          v-else
        >
          <v-list
            dense
            class="transparent"
          >
            <v-list-tile
              avatar
              @click="showDetail(item)"
              v-for="(item,index) in filteredItems"
              :key="'list-file-'+index"
            >
              <v-list-tile-avatar>
                <v-icon color="primary">tune</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <div class="container pl-0">
                  <div class="layout row">
                    <div class="flex lg4 sm12 xs12"> {{item.title}}</div>
                    <div class="flex lg4 sm12 xs12"> {{item.type}}</div>
                    <v-spacer></v-spacer>
                    <div class="caption">{{item ? formateDate(item.start) : ''}}</div>
                  </div>
                </div>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-layout>
      </div>
    </div>
    <app-section-loader :status="loader"></app-section-loader>
  </div>
</template>

<script>
import FullCalendar from 'vue-fullcalendar';

import { getCalendars } from '@/api/calendar';



export default {
  components: {

    FullCalendar,
  },
  props: {
    type: {
      type: String,
      default: 'image'
    }
  },


  data: () => ({
    items: [{ title: "View", id: 1 }, { title: "Download", id: 2 }],
    snackbar: false,
    snackbarMessage: '',
    loading: false,
    timeout: 2000,
    search: '',
    y: 'top',
    size: 'lg',
    view: 'grid',

    dropUsers: [],
    fcEvents: [],

  }),
  computed: {
    filteredItems () {
      console.log(this.search);
      return this.fcEvents.filter(item => {
        if (!this.search) return this.fcEvents;
        return (item.title.toLowerCase().includes(this.search.toLowerCase()));
      });
    }
  },
  created () {
    this.initialize();
  },
  methods: {
    clearSearch () {
      this.search = "";
    },
    handleDayClick (day, e) {
      this.dialog = true;
    },
    handleEventClick (e, event, pos) {
      this.dialog = true;

    },

    back () {
      this.view = 'grid';
      this.documents = this.allFiles;
    },
    initialize () {
      this.loader = true;
      getCalendars('')
        .then(response => {
          this.fcEvents = response.data;
          console.log(this.fcEvents);
          this.loader = false;

        })
        .catch(() => {
          this.loader = false;
        });
    },
    formateDate (string) {
      return string ? new Date(string).toLocaleDateString() : '';
    },
    close () {
      this.dialog = false;
      this.initialize();
      setTimeout(() => {

        this.editedIndex = -1;
      }, 300);
    },
  }
};
</script>
<style lang="stylus" scoped>
.media {
  &-cotent--wrap, &-menu {
    min-width: 260px;
    border-right: 1px solid #eee;
    min-height: calc(100vh - 50px - 64px);
  }

  &-detail {
    min-width: 300px;
    border-left: 1px solid #eee;
  }
}
</style>
<style scoped>
.fullwidth {
  width: 100% !important;
  max-width: 100%;
}
</style>
 <style>
.red {
  background: rgb(235, 77, 77) !important;
  color: whitesmoke !important;
}
.blue {
  background: rgb(59, 59, 163) !important;
  color: whitesmoke !important;
}
.orange {
  background: orange !important;
  color: white !important;
}
.green {
  background: rgb(49, 155, 49) !important;
  color: white !important;
}
.blue,
.orange,
.red,
.green {
  font-size: 13px;
  font-weight: 500;
  text-transform: capitalize;
}
.event-item {
  padding: 2px 0 2px 4px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/calendar/Calendarpage.vue